import React from 'react';
import CardSkeleton from '../CardSkeleton';

interface SkeletonCardListProps {
  count?: number;
}

const SkeletonCardList: React.FunctionComponent<SkeletonCardListProps> = ({ count = 8 }) => (
  <>
    {Array.from({ length: count }).map((_, index) => (
      <CardSkeleton key={index} />
    ))}
  </>
);

export default SkeletonCardList;
